import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  container: {
    height: 'calc(100vh - 83px)',
    display: 'flex',
    padding: '8px 8px'
  },
  headerGrid: {
    height: 88,
    boxSizing: 'border-box',
  },
  headerRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    marginBottom: 20,
  }
}));

export default useStyles;